"use client";
import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import "ace-builds/css/ace.css";
import "ace-builds/css/theme/dreamweaver.css";
import "ace-builds/css/theme/ambiance.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
import "devexpress-reporting/dist/css/dx-reportdesigner.css";
import ReportViewer, {
  RequestOptions,
} from "devexpress-reporting-react/dx-report-viewer";
import { useRef, useEffect } from "react";

let baseURL = "";
if (window.location.hostname === "localhost") {
  baseURL = process.env.REACT_APP_API_BASE_URL_LOCAL || "http://localhost:3050";
} else {
  baseURL = process.env.REACT_APP_API_BASE_URL_WEB || "http://localhost:3050";
}

function dateToEpoch(date) {
  return new Date(date).getTime() / 1000;
}

function ReportViewerApp({ url, startDate, endDate, onReportLoaded }) {
  const startEpoch = dateToEpoch(startDate);
  const endEpoch = dateToEpoch(endDate);
  const hasCalledCallback = useRef(false);

  // Reset the flag when the report URL changes
  useEffect(() => {
    hasCalledCallback.current = false;
  }, [url, startDate, endDate]);

  const callbacks = {
    // This event fires when the document is fully loaded in the viewer
    DocumentReady: (s, e) => {
      if (!hasCalledCallback.current && onReportLoaded) {
        hasCalledCallback.current = true;
        // Small delay to ensure everything is fully rendered
        setTimeout(() => {
          onReportLoaded();
        }, 500);
      }
    },
    // Optional: track when report preview starts building
    PreviewClick: (s, e) => {
      return;
    },
    // Optional: handle errors
    CustomizeParameterEditors: (s, e) => {
      return;
    },
  };

  return (
    <ReportViewer
      reportUrl={
        url
          ? url !== ""
            ? url.split("/")[0] + "/" + startEpoch + "/" + endEpoch
            : "TestReport"
          : "TestReport"
      }
      callbacks={callbacks}
    >
      <RequestOptions host={baseURL + "/"} invokeAction="DXXRDV" />
    </ReportViewer>
  );
}
export default ReportViewerApp;
